import { Alert, Button, Input } from '30pay/components';
import { Radio } from 'antd';
import { useEffect, useState } from 'react';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import {
    __BuyUUSDWithdrawMethodConvertBoxProps,
    __BuyUUSDWithdrawMethodsEnums,
} from './buyUUSDWithdrawMethod.interface';
import { ConvertBoxDataType } from '../../convertBox.index';

const BuyUUSDWithdrawMethod: React.FC<__BuyUUSDWithdrawMethodConvertBoxProps> = (props) => {
    const [withdrawMethod, setWithdrawMethod] = useState<__BuyUUSDWithdrawMethodsEnums>(
        __BuyUUSDWithdrawMethodsEnums.get,
    );
    const [accountNumber, setAccountNumber] = useState<string | undefined>();

    function submitHandler() {
        const output: ConvertBoxDataType = {
            // for "دریافت ووچر" we don't need accountNumber
            // if in future "account" is enabled, this function still works for that path
            walletAddress: withdrawMethod === __BuyUUSDWithdrawMethodsEnums.account ? accountNumber : undefined,
        };
        props.onSubmit(output);
    }

    function backHandler() {
        props.onBack();
    }

    // 🔥 Auto-submit for UUSD when only "دریافت ووچر" matters
    useEffect(() => {
        // currently "get" is always the only enabled path
        if (withdrawMethod === __BuyUUSDWithdrawMethodsEnums.get) {
            submitHandler();
        }
        // we deliberately don't depend on accountNumber; voucher doesn't need it
    }, [withdrawMethod]);

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <Card className="flex-1" title="روش دریافت" titleDivider>
                <div className="flex flex-col gap-6">
                    <Radio.Group
                        buttonStyle="solid"
                        onChange={(e) => setWithdrawMethod(e.target.value)}
                        value={withdrawMethod}
                    >
                        <Radio value={__BuyUUSDWithdrawMethodsEnums.get}>دریافت ووچر</Radio>
                        <Radio value={__BuyUUSDWithdrawMethodsEnums.account} disabled>
                            حساب به حساب
                        </Radio>
                    </Radio.Group>
                    {withdrawMethod === __BuyUUSDWithdrawMethodsEnums.account && (
                        <div className="gap-2 flex flex-col">
                            <label className="font-bold text-base text-black-100">شماره حساب پرفکت مانی</label>
                            <Input
                                className="en"
                                value={accountNumber}
                                onChange={(e) => setAccountNumber(e.target.value)}
                                placeholder="U12345678"
                            />
                        </div>
                    )}
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button
                        disabled={
                            (withdrawMethod === __BuyUUSDWithdrawMethodsEnums.account &&
                                (!accountNumber || accountNumber === '')) ||
                            props.loading
                        }
                        loading={props.loading}
                        onClick={submitHandler}
                        className="w-full h-16"
                        type="primary"
                    >
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert
                    title="روش شارژ کیف پول:"
                    message="در این روش پس از پرداخت، ارز به صورت خودکار به کیف پول موجود در پنل کاربری شما اضافه خواهد شد."
                    variant="info"
                />
                <Alert
                    title="روش دریافت ووچر:"
                    message="در این روش پس از پرداخت٬ کدهای ووچر خود را دریافت می‌کنید."
                    variant="info"
                />
                <Alert
                    title="حساب به حساب"
                    message="در این روش پس از وارد کردن شماره حساب پرفکت مانی خود،ارز مقصد را دریافت می کنید."
                    variant="info"
                />
            </div>
        </div>
    );
};

export default BuyUUSDWithdrawMethod;
